var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RemovableCard } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { QueueSelect } from 'fable/queueSelect';
import styles from '../bulkActionsModal.module.scss';
export class BulkActionsTransferToQueue extends PureComponent {
    handleRemove() {
        this.props.setSelectedQueue(null);
        this.props.onRemove();
    }
    render() {
        const { selectedQueue, setSelectedQueue } = this.props;
        return (_jsxs(RemovableCard, Object.assign({ className: styles.actionCard, icon: "arrow-right", title: "Transfer to a different queue", onRemove: this.handleRemove }, { children: [_jsx("p", Object.assign({ className: styles.actionNote }, { children: "Transferring conversations to a different queue will cause all those conversations to open and be available for offering in the new queue. If you would like to avoid that and close the selected conversations as well, then you can create a new bulk action afterwards and use the \u201CClose\u201D action." })), _jsx(QueueSelect, { selectedQueue: selectedQueue, onSelect: setSelectedQueue })] })));
    }
}
__decorate([
    boundMethod
], BulkActionsTransferToQueue.prototype, "handleRemove", null);
